export default "__VITE_ASSET__bc69cd90__"